import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import FormSelectBox from '@views/components/Inputs/FormSelectBox';
import { useGetWeightUomList } from '@views/screens/common/hooks';
import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';
import { routeFileSelector } from '@utilz/i18n';

interface WeightUomSelectProps extends Pick<FormItemProps, 'rules' | 'name'>, Pick<SelectProps, 'placeholder'> {
  label?: string;
  editMode?: boolean;
  margin?: string;
  onChange?: (value: unknown) => void;
  tooltip?: string;
  isDefault?: boolean;
  tabIndex?: number;
  disableValidation?: boolean;
  isRequired?: boolean;
}

export const WeightUomSelect: FC<WeightUomSelectProps> = ({
  placeholder = i18n.t('translation:default.fields.weightMeasurement.placeholder'),
  label = i18n.t('translation:default.fields.weightMeasurement.label'),
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  tooltip,
  isDefault = false,
  tabIndex,
  disableValidation = false,
  isRequired = false,
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const { data: weightUomData = [], isLoading } = useGetWeightUomList();

  return (
    <FormSelectBox
      loading={isLoading}
      options={
        isDefault === true
          ? [{ label: t('translation:default.buttons.select'), value: '' }, ...weightUomData]
          : weightUomData
      }
      placeholder={placeholder}
      label={label}
      margin={margin}
      isRequired={isRequired}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      tooltip={tooltip}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      dataTestId="product-details-weight-uom"
    />
  );
};
